const EVENT_MAP = {
  CHAT_OPENED: 'Bubble clicked',
  CHAT_FORM_SUBMIT: 'Conversation Started',
  FAVORITE_ADDED: 'Favorite Added',
  FAVORITE_REMOVED: 'Favorite Removed',
};

export function trackEvent(
  event: keyof typeof EVENT_MAP,
  properties?: Record<string, any>
) {
  // Track event here
  if (window.analytics?.track == null) {
    console.info('Analytics not initialized');
    return;
  }
  window.analytics.track(event, properties);
}
